module.exports = "<app-jumbotron></app-jumbotron>\n <app-philosophycards></app-philosophycards>\n "